/* eslint-disable no-mixed-operators */
/* eslint react/jsx-pascal-case: 0 */
import * as React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Helper from "../../../core/libraries/Helper";
import RbLabel, { LabelSize } from "../../../bosch-react/components/label/RbLabel";
import { RootState } from "../../../store/store";
import { ConstrainMode, DirectionalHint, IColumn, IListProps, Link, SelectionMode, ShimmeredDetailsList, TooltipHost } from "@fluentui/react";
import { IAccountReport } from "../types";
import { IUserProfile } from "../../Auth/types";
import { showDialog, showToastMessage } from "../../Dialog/actions";
import { getMyApprovedReports } from "../services";
import ListActionsMenu from "../../../core/common/ListActionsMenu";
import DetailsListWrapper from "../../../core/components/DetailsListWrapper/DetailsListWrapper";
import Configuration from "../../../core/libraries/Configuration";
import Template from "../../../core/libraries/Template";

interface IState {
  approvedReports: IAccountReport[] | null,
  filteredItems: IAccountReport[] | null,
  selectedItem: any,
  showCancelDialog: boolean,
  showWorkflowIdDialog: boolean,
}

export interface MyApprovedUploadsProps {
  userProfile: IUserProfile | undefined,
  showDialog: typeof showDialog,
  showToastMessage: typeof showToastMessage,
}

class MyApprovedUploads extends React.Component<MyApprovedUploadsProps, IState> {

  private timeoutId: NodeJS.Timeout | null = null;


  constructor(props: MyApprovedUploadsProps) {
    super(props);
    this.state = {
      selectedItem: null,
      showCancelDialog: false,
      showWorkflowIdDialog: false,
      approvedReports: null,
      filteredItems: null
    };
  }

  componentDidMount() {
    Helper.runNewTask(() => {
      this.getApprovedUploads();
    });
  }


  shimmeredDetailsListProps: IListProps = {
    renderedWindowsAhead: 0,
    renderedWindowsBehind: 0,
  };


  normalModeColumns: IColumn[] = [
    {
      key: 'title',
      name: 'Title',
      fieldName: 'Title',
      currentWidth: Helper.resizeColumnByScreenWidth(10),
      minWidth: Helper.resizeColumnByScreenWidth(10),
      isResizable: true,
      isRowHeader: true,
      data: 'string',
      isPadded: true,
      onRender: (item: IAccountReport) => {
        return (
          <Link target='_blank' href={Helper.generateAccessMediatorUrl(item.id)}>{item.title}</Link>
        );
      }
    },
    {
      key: 'authors',
      name: 'Author(s)',
      fieldName: 'Authors',
      currentWidth: Helper.resizeColumnByScreenWidth(12),
      minWidth: Helper.resizeColumnByScreenWidth(12),
      isResizable: true,
      isRowHeader: true,
      data: 'string',
      isPadded: true,
      isMultiline: true,
      onRender: (item: IAccountReport) => {
        const authors = item.author ? item.author.split(",") : [];
        return Template.renderReadOnlyPeople(authors);
      }
    },
    {
      key: 'basicProps',
      name: 'Basic Information',
      fieldName: 'Basic Information',
      currentWidth: Helper.resizeColumnByScreenWidth(15),
      minWidth: Helper.resizeColumnByScreenWidth(15),
      isResizable: true,
      isRowHeader: true,
      data: 'string',
      isPadded: true,
      isMultiline: true,
      onRender: (item: IAccountReport) => {
        return (
          <>
            <RbLabel isInline={false} size={LabelSize.Small} >Division: <strong>{item.division}</strong></RbLabel>
            <RbLabel isInline={false} size={LabelSize.Small} >Department: <strong>{item.department}</strong></RbLabel>
            <RbLabel isInline={false} size={LabelSize.Small} >Upload Type: <strong>{item.uploadType}</strong></RbLabel>
          </>
        );
      }
    },
    {
      key: 'keywords',
      name: 'Keywords',
      fieldName: 'Keywords',
      currentWidth: Helper.resizeColumnByScreenWidth(15),
      minWidth: Helper.resizeColumnByScreenWidth(15),
      isResizable: true,
      isRowHeader: true,
      data: 'string',
      isPadded: true,
      onRender: (item: IAccountReport) => {
        return (
          <TooltipHost
            directionalHint={DirectionalHint.leftCenter}
            content={item.keywords}>
            {item.keywords}
          </TooltipHost>
        );
      }
    },
    {
      key: 'workflowId',
      name: 'Workflow Id',
      fieldName: 'Workflow Id',
      currentWidth: Helper.resizeColumnByScreenWidth(15),
      minWidth: Helper.resizeColumnByScreenWidth(15),
      isResizable: true,
      isRowHeader: true,
      data: 'string',
      isPadded: true,
      onRender: (item: IAccountReport) => {
        return (
          <RbLabel isInline={false} size={LabelSize.Small} ><strong>{item.workflowId}</strong></RbLabel>
        );
      }
    },
  ];

  async getApprovedUploads() {
    this.setState({
      filteredItems: null
    })
    let approvedReports: IAccountReport[] = []
    try {
      approvedReports.push(...await getMyApprovedReports());
      this.setState({
        approvedReports: approvedReports,
        filteredItems: approvedReports
      })
    } catch (error) {
      this.props.showDialog(false)
    }
  }

  render() {
    let { filteredItems } = this.state
    let element = (
      <div className="ms-Grid">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm1" />
          <div className="ms-Grid-col ms-sm10">

            <div className="ms-Grid">
              <div className="ms-Grid-row">
                <RbLabel className="header-title" size={LabelSize.Large}> My Approved Uploads </RbLabel>
                <ListActionsMenu
                  columns={this.normalModeColumns}
                  items={filteredItems || []}
                  searchText={(value: any) => { this._onChangeText(value) }}
                  showAdminResults={false}
                  disableAdminMode
                  getAdminData={() => {
                    Helper.runNewTask(() => {
                      this.getApprovedUploads();
                    });
                  }}></ListActionsMenu>
              </div>
              <DetailsListWrapper>
                <ShimmeredDetailsList
                  setKey="set"
                  compact={true}
                  items={filteredItems || []}
                  constrainMode={ConstrainMode.unconstrained}
                  columns={this.normalModeColumns}
                  selectionMode={SelectionMode.single}
                  enableShimmer={!filteredItems}
                  ariaLabelForShimmer="Content is being fetched"
                  ariaLabelForGrid="Pending reports detail"
                  listProps={this.shimmeredDetailsListProps}
                  onRenderDetailsHeader={Configuration.onRenderStickyDetailsHeader}
                  onShouldVirtualize={() => { return true }}
                />
              </DetailsListWrapper>
            </div>

          </div>
          <div className="ms-Grid-col ms-sm1" />
        </div>
      </div>
    );
    return element;
  }
  private _onChangeText = (text: string): void => {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.timeoutId = setTimeout(() => {
      this.setState({
        filteredItems: text ? [...this.state.approvedReports ?? []].filter(i => i.title && i.title.toLowerCase().indexOf(text.toLowerCase()) > -1
          || i.workflowId && i.workflowId.toLowerCase().indexOf(text.toLowerCase()) > -1
          || i.keywords && i.keywords.toLowerCase().indexOf(text.toLowerCase()) > -1) : [...this.state.approvedReports ?? []],
      });
    }, 500);
  };
}

const mapStateToProps = (state: RootState) => ({
  userProfile: state.auth.userProfile,
  isLoading: state.search.isLoading,
});

export default connect(mapStateToProps, {
  showDialog,
  showToastMessage,
})(MyApprovedUploads);
